<template>
    <div>
         <el-dialog
        :title="$t('toLogin.loginTip')"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose"
      >
        <div class="login_tip">
          <i class="iconfont icon-xuanzhong1"></i>
          <div class="tip">{{$t('toLogin.ifToLogin')}}</div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">{{$t('toLogin.canel')}}</el-button>
          <el-button type="primary" @click="toLogin()">{{$t('toLogin.confirm')}}</el-button>
        </span>
      </el-dialog> 
    </div>
</template>

<script>
import bus from "@/bus";
export default {
    mounted(){
        bus.$on('LoginDialogEmit',()=>{
            this.dialogVisible = true
        })
    },
    data(){
        return {
             dialogVisible: false,
        }
    },
    methods:{
            toLogin() {
      this.dialogVisible = false;
      var query = this.$route.fullPath;
      this.$router.push(`/login?redirect=${query}`);
    },
    }
}
</script>

<style lang="scss">
.login_tip {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  i {
    font-size: 40px;
    color: rgba(248, 187, 134, 1);
    font-weight: 600;
    margin-bottom: 10px;
  }
  .tip {
    font-weight: 600;
    font-size: 22px;
  }
}
</style>